// ** React Imports
import { lazy } from 'react';

/** Full-page destinations for things that previously only had a drawer. */
const WorkspaceRoutes = [
  {
    path: 'notifications/inbox',
    component: lazy(() => import('views/notification/inbox')),
  },
  {
    path: 'tasks',
    component: lazy(() => import('views/tasks')),
  },
];

export default WorkspaceRoutes;
